import React, { useState, useEffect, useMemo } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { ProgramRequestItem } from './ProgramRequestItem';
import { ProgramGroupItem } from './ProgramGroupItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { addDurationToTimeValue } from '../../../util/time-util';
import './program-block-item.css';

export function ProgramBlockItem(props) {
    const { item: blockItem, isActive, onToggle, contentHeight } = props;
    const [height, setHeight] = useState(0);
    const blockTimesStr = useMemo(() => {
        return (
            '(' +
            blockItem.startTime +
            ' - ' +
            addDurationToTimeValue(blockItem.startTime, blockItem.fullDuration) +
            ')'
        );
    }, [blockItem]);

    useEffect(() => {
        if (isActive) {
            setHeight(Math.max(contentHeight, 300)); // Минимальная высота 300px
        } else {
            setHeight(0);
        }
    }, [isActive, contentHeight]);

    return (
        <Card key={blockItem.id} className="mprogram-block-item">
            <Card.Header
                className="text-uppercase h6 program-block-header d-flex justify-content-between align-items-center"
                onClick={() => onToggle(blockItem.id)}
                style={{ cursor: 'pointer' }}
            >
                <div className='d-flex align-items-center'>
                    {blockItem.title} <span className="small ml-3">{blockTimesStr}</span>
                </div>
                <FontAwesomeIcon icon={faChevronDown} className={`chevron-icon ${isActive ? 'rotated' : ''}`} />
            </Card.Header>
            <div
                className="program-block-content"
                style={{
                    height: `${height}px`,
                    overflowY: 'auto',
                }}
            >
                <ListGroup variant="flush" className="bg-white">
                    {blockItem.items &&
                        blockItem.items.map((groupOrReqItem) => (
                            <React.Fragment key={groupOrReqItem.id}>
                                {groupOrReqItem.items ? (
                                    <ProgramGroupItem item={groupOrReqItem} />
                                ) : (
                                    <ProgramRequestItem item={groupOrReqItem} />
                                )}
                            </React.Fragment>
                        ))}
                </ListGroup>
            </div>
        </Card>
    );
}
